export default __webpack_public_path__ + "static/media/ssis.aff7608f.png";